export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const EMPTY_NOTIFICATIONS = "EMPTY_NOTIFICATIONS";

